import ApiService from "@/services/api.service"

export const TelegramService = {
  telegramConnect(superadmin = false) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}telegram/bot/connect`)
  },
  telegramInfo(superadmin = false) {
    return ApiService.get(`${superadmin ? 'superadmin/' : ''}telegram/bot/info`)
  },
  sendOTP(superadmin = false, params) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}telegram/bot/otp/send`, params, {}, { loader: false })
  },
  checkOTP(superadmin = false, params) {
    return ApiService.post(`${superadmin ? 'superadmin/' : ''}telegram/bot/otp/check`, params, {}, { loader: false })
  },
}
